import { createFileRoute } from "@tanstack/react-router";
import TelemetryPage from "../../components/Telemetry/TelemetryPage";

export const Route = createFileRoute("/_layout/telemetry")({
  component: TelemetryPage,
});
